export default __webpack_public_path__ + "static/media/chestguard_of_the_wicked.83f6697f.jpg";